import * as React from "react";
import ImageView from "../../../components/SmartImage";
import { formatAspect } from "../../../utils/banner";
import { formatBannerGridSize } from "../../../utils/banner";
import { isNotBlankArray } from "../../../utils/array";
import { Container, CarouselWrapper } from "./styles";
class Carousel extends React.Component {
    constructor(props) {
        super(props);
        this.onChangePosition = (type) => () => {
            const { current } = this.state;
            const { banners } = this.props;
            const max = banners.length - 1;
            if (type === "left") {
                this.setState({
                    current: current > 0 ? current - 1 : max,
                });
            }
            if (type === "right") {
                this.setState({
                    current: current < max ? current + 1 : 0,
                });
            }
        };
        this.renderBody = () => {
            let { banners, showArrow, showDots, style = {}, minWidth = 0, width = "0", placeholderBg, } = this.props;
            if (!isNotBlankArray(banners)) {
                return null;
            }
            const banner = banners[0];
            const { width: gridWidth } = formatBannerGridSize(banner, Math.max(+width, minWidth));
            const { current } = this.state;
            if (banners.length <= 1) {
                showDots = false;
                showArrow = false;
            }
            return (React.createElement(CarouselWrapper, { onMouseEnter: () => this.setState({ pause: true }), onMouseLeave: () => this.setState({ pause: false }), style: Object.assign(Object.assign({}, style), { width: +gridWidth ? `${gridWidth}px` : "auto" }) },
                React.createElement("ul", { className: "carouselList", style: {
                        width: `${banners.length * 100}%`,
                        transform: `translateX(-${(100 / banners.length) * current}%)`,
                    } }, banners.map((item, index) => {
                    const link = item.link;
                    return (React.createElement("li", { key: index },
                        React.createElement("a", { "data-href": link, href: link, onClick: e => this.linkTo(e, link) },
                            React.createElement(ImageView, { src: item.img, aliSize: 14.4, qnParams: { w: 1440 }, isLazyLoad: false, online: this.props.online, placeholder: placeholderBg, fallbackSrc: placeholderBg }))));
                })),
                showArrow && [
                    React.createElement("i", { key: "left", onClick: this.onChangePosition("left"), className: "leftBtn" }),
                    React.createElement("i", { key: "right", onClick: this.onChangePosition("right"), className: "rightBtn" }),
                ],
                showDots && (React.createElement("ul", { className: "dots" }, banners.map((_, index) => (React.createElement("li", { onClick: () => this.setState({ current: index }), className: index === current ? "active" : "", key: index })))))));
        };
        this.state = {
            current: 0,
            pause: false,
        };
    }
    componentDidMount() {
        const { banners } = this.props;
        if (banners.length <= 1) {
            return;
        }
        setInterval(() => {
            const { current } = this.state;
            if (this.state.pause) {
                return;
            }
            this.setState({
                current: current === banners.length - 1 ? 0 : current + 1,
            });
        }, 3000);
    }
    linkTo(e, link) {
        e.preventDefault();
        if (this.props.onClick) {
            this.props.onClick(link);
        }
        if (link.trim()) {
            open(link, "_blank");
        }
    }
    render() {
        let { positionId, className = "", style = {}, banners, width = 0 } = this.props;
        const banner = banners[0];
        const bannerHeight = formatAspect(banner.height || "");
        return (React.createElement(Container, { id: positionId, className: className, gridHeight: bannerHeight || 300, gridWidth: width, style: Object.assign({}, style) },
            React.createElement(React.Fragment, null, this.renderBody())));
    }
}
Carousel.defaultProps = {
    showDots: true,
    showArrow: false,
};
export default Carousel;
